
// import {apiurl} from '@/services/config'
import { handleResponse } from '@/services/handleresponse'

const API_URL = 'https://api.irmastore.id/irmapay/'
// const API_URL = 'http://localhost:8081/irmapay/'

export const WalletService = {
    getChannelList,
    getWallet,
    getBanks,
    getCashin,
    getCashOut,
    addBanks,
    doCashOut,
    deleteBanks,
    getWalletHistori, 
    getOtp
} 
function getWalletHistori (opt) {
    console.log(opt)

    var sort="id"
    var sorder="DESC"
    if(opt.sortBy){
        console.log(opt.sortBy)
    }
    if(opt.sortDesc){
        if(opt.sortDesc[0]){
            sorder="DESC"
        }
    }
    if(opt.itemsPerPage<0){
        opt.itemsPerPage=10000
    }
    let page=opt.page-1;
    let sorting=sort+","+sorder
    return fetch(API_URL + 'wallet/history?identity=111&awal='+opt.awal+"&akhir="+opt.akhir+'&page='+page+'&size='+opt.itemsPerPage+"&sort="+sorting, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}
function getCashOut (opt) {
    console.log(opt)

    var sort="id"
    var sorder="DESC"
    if(opt.sortBy){
        console.log(opt.sortBy)
    }
    if(opt.sortDesc){
        if(opt.sortDesc[0]){
            sorder="DESC"
        }
    }
    if(opt.itemsPerPage<0){
        opt.itemsPerPage=10000
    }
    let page=opt.page-1;
    let sorting=sort+","+sorder
    return fetch(API_URL + 'wallet/cashout?identity=111&awal='+opt.awal+"&akhir="+opt.akhir+'&page='+page+'&size='+opt.itemsPerPage+"&sort="+sorting, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}

function getCashin (opt) {
    console.log(opt)
    var sort="id"
    var sorder="DESC"
    if(opt.sortBy){
        console.log(opt.sortBy)
    }
    if(opt.sortDesc){
        if(opt.sortDesc[0]){
            sorder="DESC"
        }
    }
    if(opt.itemsPerPage<0){
        opt.itemsPerPage=10000
    }
    let page=opt.page-1;
    let sorting=sort+","+sorder
    return fetch(API_URL + 'wallet/cashin/'+opt.status+'?identity=111&awal='+opt.awal+"&akhir="+opt.akhir+'&page='+page+'&size='+opt.itemsPerPage+"&sort="+sorting, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}

function doCashOut (postdata) {
    return fetch(API_URL + 'wallet/cashout', {
        method: 'POST',
        body: JSON.stringify({ postdata }.postdata),
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}

function addBanks (postdata) {
    postdata.identity=111;
    return fetch(API_URL + 'wallet/bank', {
        method: 'POST',
        body: JSON.stringify({ postdata }.postdata),
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}
function deleteBanks (idbank) {
    return fetch(API_URL + 'wallet/bank/'+idbank, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}
function getBanks () {
    return fetch(API_URL + 'banks', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}

function getChannelList () {
    return fetch(API_URL + 'channel', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}

function getWallet () {
    return fetch(API_URL + 'wallet?identity=111', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}

function getOtp(detail){
  return fetch(API_URL + 'wallet/otp?detail='+detail, {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
    }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}
